import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from 'react';
import AuthContext from '../AuthContextComponent/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import SelectTenantPopup from "../SelectTenantComponent/SelectTenantPopup";
import { ReactComponent as PartnerIcon } from '../../Assets/img/Partner.svg';
import { ReactComponent as HelpIcon } from '../../Assets/img/Helpicon.svg';
import { ReactComponent as AboutIcon } from '../../Assets/img/Infoicon.svg';
import { ReactComponent as Certificate } from '../../Assets/img/Certificates.svg';
import { ReactComponent as Configuration } from '../../Assets/img/Configurationblack.svg';
import { ReactComponent as Countries } from '../../Assets/img/Countries.svg';
import { ReactComponent as Devicemodel } from '../../Assets/img/Device-models.svg';
import { ReactComponent as Device } from '../../Assets/img/Devices.svg';
import { ReactComponent as Partner } from '../../Assets/img/Partners.svg';
import { ReactComponent as Userrole } from '../../Assets/img/User-roles.svg';
import { ReactComponent as User } from '../../Assets/img/Users.svg';

function TopNavigation(props) {
    const [selectTenantPopup, setSelectTenantPopup] = useState(false);
    const authCtx = useContext(AuthContext);
    const role = authCtx.role;
    let navigate = useNavigate();

    function openSelectTenantPopup() {
        setSelectTenantPopup(true)
    }
    function closeSelectTenantPopup() {
        setSelectTenantPopup(false)
    }

    return (
        <div>
            <div className="top-navigation-container">
                <div className="top-navigation-header">
                    {/*  <PartnerIcon className="top-navigation-partnericon" />*/}
                    {(authCtx.selectedPageName == "Devices" ? <Device /> : "")}
                    {(authCtx.selectedPageName == "Configurations" ? <Configuration /> : "")}
                    {(authCtx.selectedPageName == "Device-Models" ? <Devicemodel /> : "")}
                    {(authCtx.selectedPageName == "Certificates" ? <Certificate /> : "")}
                    {(authCtx.selectedPageName == "TenantUsers" ? <User /> : "")}
                    {(authCtx.selectedPageName == "Partners" ? <Partner /> : "")}
                    {(authCtx.selectedPageName == "Countries" ? <Countries /> : "")}
                    {(authCtx.selectedPageName == "Users" ? <User /> : "")}
                    {(authCtx.selectedPageName == "About" ? <AboutIcon /> : "")}
                    {(authCtx.selectedPageName == "Help" ? <HelpIcon /> : "")}
                    {(authCtx.selectedPageName == "Change-password" ? <User /> : "")}
                    <div className="top-navigation-roleheader">
                        Tenant Management
                    </div>
                    <div class="top-navigation-dividers"></div>
                    <div className='top-navigation-moduleheader '>
                        {(authCtx.selectedPageName == "Devices" ? 'Devices' : "")}
                        {(authCtx.selectedPageName == "Configurations" ? 'Configurations' : "")}
                        {(authCtx.selectedPageName == "Device-Models" ? 'Device Models' : "")}
                        {(authCtx.selectedPageName == "Certificates" ? 'Certificates' : "")}
                        {(authCtx.selectedPageName == "TenantUsers" ? 'Users' : "")}
                        {(authCtx.selectedPageName == "Partners" ? 'Partners' : "")}
                        {(authCtx.selectedPageName == "Countries" ? 'Countries' : "")}
                        {(authCtx.selectedPageName == "Users" ? 'Users' : "")}
                        {(authCtx.selectedPageName == "About" ? 'About' : "")}
                        {(authCtx.selectedPageName == "Help" ? 'Help' : "")}
                        {(authCtx.selectedPageName == "Change-password" ? 'Change Password' : "")}
                    </div>
                </div>
                {authCtx.role == "Partner" == "" && < div className="top-navigation-tenantselectioncontainer" onClick={openSelectTenantPopup}>
                    <div className="top-navigation-tenant">Tenant</div>
                    <div class="top-navigation-divider"></div>
                    <div className="top-navigation-tenant">
                        <div className="tenant-label">COUNTRY</div>
                        <div className="tenant-value">
                            {authCtx.selectedCountryName  || 'N/A'}
                        </div>
                    </div>
                    <div class="top-navigation-divider"></div>
                    <div className="top-navigation-tenant">
                        <div className="tenant-label">PARTNER</div>
                        <div className="tenant-value">
                            {authCtx.selectedPartnerName || 'N/A'}
                        </div>
                    </div>
                </div>}
            </div>
            {selectTenantPopup && <SelectTenantPopup onClose={closeSelectTenantPopup} onPageReset={props.onPageReset} />}
        </div>
    );
}
export default TopNavigation;